import { saveAs } from 'file-saver'
import moment from 'moment'
import { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'

//UI
import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, Spacer } from '@chakra-ui/react'
import { toast } from 'react-toastify'

import useOffer from '@/features/offers/hooks/useOffer'
import useOfferList from '@/features/offers/hooks/useOfferList'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { createExcelBlob, createExcelFromAoA } from '@/utils/fileHelper'
import CreateOfferBatchUpdateModal from '../../Modal/CreateOfferBatchUpdateModal'
import { maintenanceSummaryColumnKeys } from './maintenanceSummary.constant'
import { camelToWords } from '@/utils/stringHelper'

const MaintenanceSummaryListHeader = ({ offerCount = 0, tableState }) => {
  const [createOfferBatchUpdateModalDetail, setCreateOfferBatchUpdateModalDetail] = useState({
    show: false,
  })

  const { useUploadOffers, useBatchUpdateOffers } = useOffer()
  const { useFetchMaintenanceSummary } = useOfferList()

  const { data: allOfferResponse } = useFetchMaintenanceSummary({
    page: 1,
    pageSize: 0,
  })

  const tableProfiles = [
    {
      id: 'p1',
      profileName: 'Default Profile',
      tableDetails: {},
      needSave: false,
      isDefault: true,
    },
  ]

  const dispatch = useDispatch()
  const uploadOffers = useUploadOffers()
  const batchUpdateOffers = useBatchUpdateOffers()

  const handleGetBatchUpdateTemplate = () => {
    setCreateOfferBatchUpdateModalDetail({
      show: true,
    })
  }

  const handleDownload = useCallback(() => {
    if (!allOfferResponse?.data) return
    if (!tableState?.columnVisibility) {
      toast.error('Column visibility is not set. Please configure the table first.')
      return
    }
    if (!Array.isArray(tableState?.columnOrder)) {
      toast.error('Column visibility is not set. Please configure the table first.')
      return
    }

    let headerKeys = []
    Object.entries(tableState.columnVisibility).forEach(([key, value]) => {
      if (key === 'action') return
      if (value) {
        headerKeys.push(key)
      }
    })

    if (headerKeys.length === 0) {
      headerKeys = maintenanceSummaryColumnKeys
    }

    const labelKeys = [...headerKeys].map((key) => camelToWords(key))

    const dateKeys = ['updatedAt', 'createdAt', 'projectStartDate', 'projectEndDate', 'offerSubmissionDate']
    // const excelData = allOfferResponse.data.map((row) => {
    //   return {
    //     ...row,
    //     projectStartDate: moment(row.projectStartDate).isValid()
    //       ? moment(row.projectStartDate).format('DD-MMM-YYYY')
    //       : '(-)',
    //     equipmentIds: row.equipmentIds.map((item) => item).join(', '),
    //     projectEndDate: moment(row.projectEndDate).isValid() ? moment(row.projectEndDate).format('DD-MMM-YYYY') : '(-)',
    //     updatedAt: moment(row.updatedAt).isValid() ? moment(row.updatedAt).format('DD-MMM-YYYY') : '(-)',
    //     createdAt: moment(row.createdAt).isValid() ? moment(row.createdAt).format('DD-MMM-YYYY') : '(-)',
    //     offerSubmissionDate: moment(row.offerSubmissionDate).isValid()
    //       ? moment(row.offerSubmissionDate).format('DD-MMM-YYYY')
    //       : '(-)',
    //     grossMargin: row.grossMargin ? row.grossMargin + '%' : '(-)',
    //   }
    // })
    // const excelBlob = createExcelBlob(excelData)

    const rowData = allOfferResponse?.data?.map((data) => {
      const row = []
      headerKeys.forEach((key) => {
        let value = data[key]

        if (key === 'contractAmountPerMonth' && (value === undefined || value === null || value === '')) {
          const startDate = data?.projectStartDate
          const endDate = data?.projectEndDate
          const totalPrice = data?.totalContractPrice
          if (startDate && endDate && totalPrice) {
            const numberOfDays = moment(endDate).diff(startDate, 'days', false)
            const numberOfMonths = ((numberOfDays + 1) / 365) * 12
            value = Math.round((totalPrice / numberOfMonths + Number.EPSILON) * 100) / 100
          }
        } else if (key === 'remainMonth' && (value === undefined || value === null || value === '')) {
          const totalMonth = parseInt(data?.month) || 0
          value = totalMonth % 12
        }

        if (key === 'contractAmountPerMonth' && typeof value === 'number') {
          value = Math.round((value + Number.EPSILON) * 100) / 100
        }

        if (value !== undefined && value !== null && value !== '') {
          if (dateKeys.includes(key)) {
            const date = moment(value).format('DD-MMM-YYYY')
            row.push(date)
          } else if (key.includes('grossMargin')) {
            row.push(Number(value) / 100)
          } else if (key === 'equipmentIds') {
            row.push(value.map((item) => item).join(', '))
          } else {
            row.push(value)
          }
        } else {
          row.push('')
        }
      })
      return row
    })

    console.log('headerKeys', headerKeys)
    console.log('labelKeys', labelKeys)

    console.log(rowData)

    const excelBlob = createExcelFromAoA([labelKeys, ...rowData])
    saveAs(excelBlob, 'Maintenance Summary.xlsx')
  }, [tableState, allOfferResponse?.data])

  const handleUpload = (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }
    dispatch(showLoadingOverlay())
    uploadOffers.mutate(
      { file },
      {
        onSettled: () => {
          dispatch(hideLoadingOverlay())
        },
      }
    )
  }

  const handleBatchUpdateOffer = async (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }
    try {
      dispatch(showLoadingOverlay())

      await batchUpdateOffers.mutateAsync({ file })
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <>
      <CreateOfferBatchUpdateModal
        modalDetail={createOfferBatchUpdateModalDetail}
        setModalDetail={setCreateOfferBatchUpdateModalDetail}
      />
      <Flex direction={'column'} gap="2">
        <Flex py="5" borderBottom="1px solid #d8dbe0">
          <Heading>Maintenance Summary ({offerCount})</Heading>
          <Spacer />

          <Flex gap={1} alignItems={'center'}>
            <Button colorScheme={'green'} onClick={handleDownload}>
              Download
            </Button>

            <NonFormUpload uploadHandler={handleUpload} />
            <Button colorScheme={'gray'} onClick={handleGetBatchUpdateTemplate}>
              Get Template
            </Button>
            <NonFormUpload uploadHandler={handleBatchUpdateOffer} title="Batch Update" />
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}

export default MaintenanceSummaryListHeader
